export const FirebaseConfig = {
	"projectId": "on-je-be6ab",
	"appId": "1:114680060605:web:7d920afcdd619ac8c9b5d4",
	"databaseURL": "https://on-je-be6ab-default-rtdb.firebaseio.com",
	"storageBucket": "on-je-be6ab.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDZkoaiX9q8IviXs-dBtOYRv_I13fyBz40",
	"authDomain": "on-je-be6ab.firebaseapp.com",
	"messagingSenderId": "114680060605",
	"measurementId": "G-LSTM0M0SRS"
};